export function notify (self, type, msg = null, offset = null) {
  if (!msg) {
    switch (type) {
      case 'success':
        msg = 'Entity saved'
        break
      case 'error':
        msg = 'Error - please try again.'
        break
      case 'warning':
        msg = 'Warning - please check the form'
        break
      case 'info':
        msg = 'Working...'
    }
  }
  if (offset >= 0) {
    self.$notify({
      title: type.charAt(0).toUpperCase() + type.slice(1),
      message: msg,
      type: type,
      offset: offset
    })
  } else {
    self.$notify({
      title: type.charAt(0).toUpperCase() + type.slice(1),
      message: msg,
      type: type
    })
  }
}
